import React from 'react';
import SyncStatusPanel from '../components/sync/SyncStatusPanel';
import SyncButton from '../components/sync/SyncButton';
import MissingProductsTable from '../components/sync/MissingProductsTable';

const SyncPage = () => {
  return (
    <div className="container mx-auto p-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Синхронизация со складом
        </h1>
        <p className="text-gray-600">
          Управление синхронизацией товаров между складом и базой данных
        </p>
      </div>

      {/* Статус синхронизации */}
      <div className="mb-6">
        <SyncStatusPanel />
      </div>

      {/* Кнопка синхронизации */}
      <div className="mb-6">
        <SyncButton />
      </div>

      {/* Товары, которых нет в БД */}
      <div className="mb-6">
        <MissingProductsTable />
      </div>
    </div>
  );
};

export default SyncPage;